import React, { useState } from "react";
import { Button, Container, Row, Nav } from "react-bootstrap";
import AboutTakaful from "../aboutTakaful";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const SmeBanner = ({ onNext }: { onNext: Function }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [activeTab, setActiveTab] = useState("standard");
  const { t } = useTranslation();
  const settings = {
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    centerMode: true, // Ensures the center slide is in focus
    beforeChange: (_, next) => setCurrentSlide(next),
    responsive: [
      {
        breakpoint: 768, // Define breakpoint for mobile (768px or smaller)
        settings: {
          slidesToShow: 1, // Show only 1 slide
          centerMode: true // Optional: Adjust as needed for mobile layout
        }
      }
    ]
  };

  // Plans data for both tabs
  const standardPlans = [
    {
      title: t("sme_banner_standard_plans_b_title"),
      limit: t("sme_banner_standard_plans_b_limit"),
      limitRs: t("sme_banner_standard_plans_b_limit_rs"),
      roomLimit: t("sme_banner_standard_plans_b_room_limit"),
      ppHospitalization: t("sme_banner_standard_plans_b_pphospitalization"),
      dayCare: t("sme_banner_standard_plans_b_day_care"),
      deliveryNormal: t("sme_banner_standard_plans_b_delivery_normal"),
      ComplicatedDelivery: t("sme_banner_standard_plans_b_complicated_delivery"),
      indivisual: 4687
    },
    {
      title: t("sme_banner_standard_plans_c_title"),
      limit: t("sme_banner_standard_plans_c_limit"),
      limitRs: t("sme_banner_standard_plans_c_limit_rs"),
      roomLimit: t("sme_banner_standard_plans_c_room_limit"),
      ppHospitalization: t("sme_banner_standard_plans_c_pphospitalization"),
      dayCare: t("sme_banner_standard_plans_c_day_care"),
      deliveryNormal: t("sme_banner_standard_plans_c_delivery_normal"),
      ComplicatedDelivery: t("sme_banner_standard_plans_c_complicated_delivery"),
      indivisual: 3719
    },
    {
      title: t("sme_banner_standard_plans_d_title"),
      limit: t("sme_banner_standard_plans_d_limit"),
      limitRs: t("sme_banner_standard_plans_d_limit_rs"),
      roomLimit: t("sme_banner_standard_plans_d_room_limit"),
      ppHospitalization: t("sme_banner_standard_plans_d_pphospitalization"),
      dayCare: t("sme_banner_standard_plans_d_day_care"),
      deliveryNormal: t("sme_banner_standard_plans_d_delivery_normal"),
      ComplicatedDelivery: t("sme_banner_standard_plans_d_complicated_delivery"),
      indivisual: 2876
    },
    {
      title: t("sme_banner_standard_plans_e_title"),
      limit: t("sme_banner_standard_plans_e_limit"),
      limitRs: t("sme_banner_standard_plans_e_limit_rs"),
      roomLimit: t("sme_banner_standard_plans_e_room_limit"),
      ppHospitalization: t("sme_banner_standard_plans_e_pphospitalization"),
      dayCare: t("sme_banner_standard_plans_e_day_care"),
      deliveryNormal: t("sme_banner_standard_plans_e_delivery_normal"),
      ComplicatedDelivery: t("sme_banner_standard_plans_e_complicated_delivery"),
      indivisual: 2594
    },
    {
      title: t("sme_banner_standard_plans_a_title"),
      limit: t("sme_banner_standard_plans_a_limit"),
      limitRs: t("sme_banner_standard_plans_a_limit_rs"),
      roomLimit: t("sme_banner_standard_plans_a_room_limit"),
      ppHospitalization: t("sme_banner_standard_plans_a_pphospitalization"),
      dayCare: t("sme_banner_standard_plans_a_day_care"),
      deliveryNormal: t("sme_banner_standard_plans_a_delivery_normal"),
      ComplicatedDelivery: t("sme_banner_standard_plans_a_complicated_delivery"),
      indivisual: 7062
    },
  ];

  const exclusivePlans = [
    {
      title: t("sme_banner_exclusive_plans_g_title"),
      limit: t("sme_banner_exclusive_plans_g_limit"),
      limitRs: t("sme_banner_exclusive_plans_g_limit_rs"),
      roomLimit: t("sme_banner_exclusive_plans_g_room_limit"),
      ppHospitalization: t("sme_banner_exclusive_plans_g_pphospitalization"),
      dayCare: t("sme_banner_exclusive_plans_g_day_care"),
      deliveryNormal: t("sme_banner_exclusive_plans_g_delivery_normal"),
      ComplicatedDelivery: t("sme_banner_exclusive_plans_g_complicated_delivery"),
      indivisual: 2510
    },
    {
      title: t("sme_banner_exclusive_plans_h_title"),
      limit: t("sme_banner_exclusive_plans_h_limit"),
      limitRs: t("sme_banner_exclusive_plans_h_limit_rs"),
      roomLimit: t("sme_banner_exclusive_plans_h_room_limit"),
      ppHospitalization: t("sme_banner_exclusive_plans_h_pphospitalization"),
      dayCare: t("sme_banner_exclusive_plans_h_day_care"),
      deliveryNormal: t("sme_banner_exclusive_plans_h_delivery_normal"),
      ComplicatedDelivery: t("sme_banner_exclusive_plans_h_complicated_delivery"),
      indivisual: 2198
    },
    {
      title: t("sme_banner_exclusive_plans_i_title"),
      limit: t("sme_banner_exclusive_plans_i_limit"),
      limitRs: t("sme_banner_exclusive_plans_i_limit_rs"),
      roomLimit: t("sme_banner_exclusive_plans_i_room_limit"),
      ppHospitalization: t("sme_banner_exclusive_plans_i_pphospitalization"),
      dayCare: t("sme_banner_exclusive_plans_i_day_care"),
      deliveryNormal: t("sme_banner_exclusive_plans_i_delivery_normal"),
      ComplicatedDelivery: t("sme_banner_exclusive_plans_i_complicated_delivery"),
      indivisual: 18903
    },
    {
      title: t("sme_banner_exclusive_plans_j_title"),
      limit: t("sme_banner_exclusive_plans_j_limit"),
      limitRs: t("sme_banner_exclusive_plans_j_limit_rs"),
      roomLimit: t("sme_banner_exclusive_plans_j_room_limit"),
      ppHospitalization: t("sme_banner_exclusive_plans_j_pphospitalization"),
      dayCare: t("sme_banner_exclusive_plans_j_day_care"),
      deliveryNormal: t("sme_banner_exclusive_plans_j_delivery_normal"),
      ComplicatedDelivery: t("sme_banner_exclusive_plans_j_complicated_delivery"),
      indivisual: 12089
    },
    {
      title: t("sme_banner_exclusive_plans_f_title"),
      limit: t("sme_banner_exclusive_plans_f_limit"),
      limitRs: t("sme_banner_exclusive_plans_f_limit_rs"),
      roomLimit: t("sme_banner_exclusive_plans_f_room_limit"),
      ppHospitalization: t("sme_banner_exclusive_plans_f_pphospitalization"),
      dayCare: t("sme_banner_exclusive_plans_f_day_care"),
      deliveryNormal: t("sme_banner_exclusive_plans_f_delivery_normal"),
      ComplicatedDelivery: t("sme_banner_exclusive_plans_f_complicated_delivery"),
      indivisual: 2659
    }
  ];

  const navigate = useNavigate();

  const handleGetStarted = (planIndivisual, planLimitRs) => {
    // Navigate to /sme with the hospitalizationLimit query parameter
    navigate(`/sme?hospitalizationLimit=${planLimitRs}`);

    // Call onNext as well to trigger whatever functionality it needs
    onNext(planIndivisual, planLimitRs);
  };
  return (
    <>
      <section className="heroBanner-sme">
        <Container className="heroBanner-smeContainer">
          <Row>
            <div className="col-md-6">
              <h1 className="sme-h1 pt-100-small-none">
                {t("sme_banner_subheading_a")}​ <span className="text-primary">{t("sme_banner_subheading_b")}</span>
              </h1>
              <p className="sehatZamin-caption SZ-caption-color pe-5">{t("sme_banner_paragraph")}</p>
              {/* <Button
                className="getQuoteSme mt-4"
                onClick={() => onNext(1)}
              >
                Get Quote
              </Button> */}
            </div>
          </Row>
        </Container>
      </section>
      <AboutTakaful />
      <div className="coverageSelection pt-5">
        <Container className="text-center">
          <h1 className="cyc-title">
            {t("choose_your")} <span className="text-primary">{t("generic_coverage")}</span>
          </h1>
          <p className="cyc-caption">{t("sme_banner_paragraph")}</p>
          <Nav
            justify
            variant="tabs"
            defaultActiveKey="standard"
            className="customNavTabs my-5"
          >
            <Nav.Item className="navItems">
              <Nav.Link
                eventKey="standard"
                onClick={() => setActiveTab("standard")}
                className={`mycustomTabs ${activeTab === "standard" ? "active-tab" : ""}`}
              >
                {t("standard")}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="navItems">
              <Nav.Link
                eventKey="exclusive"
                onClick={() => setActiveTab("exclusive")}
                className={`mycustomTabs ${activeTab === "exclusive" ? "active-tab" : ""}`}
              >
                {t("exclusive")}
              </Nav.Link>
            </Nav.Item>
          </Nav>
          <div className="slider-container text-start">
            {activeTab === "standard" && (
              <Slider {...settings}>
                {standardPlans.map((plan, index) => (
                  <div
                    key={index}
                    className={`plan-slide planBoxes ${currentSlide === index ? "active-slide" : ""}`}
                  >
                    <h3 className="plansHead mb-3">{plan.title}</h3>
                    <h3 className="planCoverages">{plan.limit}</h3>
                    <h3 className="limitRs">
                      {plan.limitRs} <span>{t("generic_rs_dot")}</span>
                    </h3>
                    <h3 className="planCoverages mt-4">{t("sme_banner_room_and_board_heading")}</h3>
                    <h4 className="planCoveragesPrice">{plan.roomLimit}</h4>
                    <h3 className="planCoverages">{t("sme_banner_pre_and_post_hospitalization_heading")}</h3>
                    <h4 className="planCoveragesPrice">{plan.ppHospitalization}</h4>
                    <h3 className="planCoverages">{t("sme_banner_day_care_surgeries_heading")}</h3>
                    <h4 className="planCoveragesPrice">{plan.dayCare}</h4>
                    <Button
                      className={`getStartedBtn ${currentSlide !== index ? "inactive-btn" : ""}`}
                      onClick={() => handleGetStarted(plan.indivisual, plan.limitRs)}
                      // disabled={currentSlide !== index}
                    >
                      {t("get_started")}
                    </Button>
                  </div>
                ))}
              </Slider>
            )}
            {activeTab === "exclusive" && (
              <Slider {...settings}>
                {exclusivePlans.map((plan, index) => (
                  <div
                    key={index}
                    className={`plan-slide planBoxes ${currentSlide === index ? "active-slide" : ""}`}
                  >
                    <h3 className="plansHead mb-3">{plan.title}</h3>
                    <h3 className="planCoverages">{plan.limit}</h3>
                    <h3 className="limitRs">
                      {plan.limitRs} <span>{t("generic_rs_dot")}</span>
                    </h3>
                    <h3 className="planCoverages mt-4">{t("sme_banner_room_and_board_heading")}</h3>
                    <h4 className="planCoveragesPrice">{plan.roomLimit}</h4>
                    <h3 className="planCoverages">{t("sme_banner_pre_and_post_hospitalization_heading")}</h3>
                    <h4 className="planCoveragesPrice">{plan.ppHospitalization}</h4>
                    <h3 className="planCoverages">{t("sme_banner_day_care_surgeries_heading")}</h3>
                    <h4 className="planCoveragesPrice">{plan.dayCare}</h4>
                    <Button
                      className={`getStartedBtn ${currentSlide !== index ? "inactive-btn" : ""}`}
                      onClick={() => handleGetStarted(plan.indivisual, plan.limitRs)}
                      // disabled={currentSlide !== index}
                    >
                      {t("get_started")}
                    </Button>
                  </div>
                ))}
              </Slider>
            )}
          </div>
        </Container>
      </div>
    </>
  );
};

export default SmeBanner;
